var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocalpro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 98,
    viewBox: "0 0 60 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4932 98L59.993 87.5046V12.0438L38.4932 19.8206V98Z",
    fill: "#223B7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4934 70.1036L0.0712891 59.6231V7.97852L38.4934 19.8206V70.1036Z",
    fill: "#0870B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M23.5591 0.84314L0 8.08089L38.4962 19.8207L60 12.0439L23.5591 0.84314Z",
    fill: "#F59F40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0879 62.3098V46.9431H19.8675V62.3098H18.0879Z",
    fill: "#006FBA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4934 97.6204L0.0712891 83.3981V59.1046L38.4934 69.5914V97.6204Z",
    fill: "#0870B8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.10325 69.2367L36.3163 78.5517L35.8527 80.2855L1.63965 70.9705L2.10325 69.2367Z",
    fill: "#006FBA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8125 88.9817L18.9002 41.4116L20.6799 41.415L20.5922 88.9851L18.8125 88.9817Z",
    fill: "#006FBA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36035 66.9637C6.9196 64.0388 15.0009 66.1646 14.6851 69.8298L6.36035 66.9637Z",
    fill: "#FBA03D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8916 53.121V40.6536L32.8284 49.0643V61.7758L4.8916 53.121Z",
    fill: "#223B7F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8916 70.0499V55.1639L32.4673 64.3303V79.47L4.8916 70.0499Z",
    fill: "#223B7F"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8916 80.6435V66.5813L32.3773 76.5256V90.8279L4.8916 80.6441V80.6435Z",
    fill: "#223B7F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.96537 66.3809L36.2574 78.0629L35.8399 79.2745L2.54785 67.5924L2.96537 66.3809Z",
    fill: "#006FBA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7432 15.9572L41.2552 14.9666L45.5662 13.2666V2.52258L38.7432 4.32202V15.9572Z",
    fill: "#223B7F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7438 15.9571L26.5508 12.3108V1.58167L38.7438 4.32197V15.9571Z",
    fill: "#0870B8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M34.1042 0L26.5283 1.60509L38.7451 4.32139L45.5693 2.52195L34.1042 0Z",
    fill: "#F59F40"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2559 14.9665V8.7691L43.4385 7.92883V14.1062L41.2559 14.9665Z",
    fill: "#0870B8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00977 38.7467V26.2793L32.9466 34.69V47.4015L5.00977 38.7467Z",
    fill: "#223B7F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00977 24.3913V11.9238L32.9466 20.3345V33.046L5.00977 24.3913Z",
    fill: "#223B7F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98926 83.1108L10.4313 11.681L12.211 11.6922L11.7689 83.122L9.98926 83.1108Z",
    fill: "#006FBA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0127 86.8303L18.4548 15.4005L20.2344 15.4117L19.7923 86.8415L18.0127 86.8303Z",
    fill: "#006FBA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.085 43.0994V39.9603L32.9239 38.7382V41.8167L20.085 43.0989V43.0994Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.085 57.7225V54.6315L32.7968 53.3612V56.4888L20.085 57.7219V57.7225Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8301 72.6021V69.5511L32.5419 68.2408V71.328L19.8301 72.3456V72.6021Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8301 86.1989V83.0668L32.2877 81.8376V85.0068L19.8301 86.1983V86.1989Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20.085 28.733V25.7948L32.9239 24.3717V27.4502L20.085 28.7324V28.733Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7842 89.4957L26.2263 18.0659L28.0059 18.0771L27.5638 89.5069L25.7842 89.4957Z",
    fill: "#006FBA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalpro);
export default __webpack_public_path__ + "static/media/localpro.b46d4949a985f7871596bdf9ae0bc938.svg";
export { ForwardRef as ReactComponent };